import { normalize } from 'normalizr';
import * as schema from '../schema';
import * as actionTypes from './actionTypes';
import { axiosProtected, axiosDownload } from '../../axios-wizard';
import { currentLang } from './support';


// update

export const updateProjectOfferPositions = (project_id, project_offer_positions) => {
    const url = '/api/project_offer_positions/bulk_update';
    return dispatch => {
        dispatch(updateProjectOfferPositionsStart());
    
        return axiosProtected.put(url, { 
            project_offer_positions: project_offer_positions.map(position => ({
                id: position.id,
                rounded_verkaufseinheit: position.rounded_verkaufseinheit,
                price: position.price,
                discount: position.discount,
                rowsum: position.rowsum
            })),
            project_id: project_id 
        })
        .then(response => {
            const normalizedPositions = normalize(response.data, { 
                project_offer_positions: schema.projectOfferPositions 
            });
            dispatch(updateProjectOfferPositionsSuccess(normalizedPositions));
        })
        .catch(error => {
            dispatch(updateProjectOfferPositionsFailed());
        });
    };
};

export const updateProjectOfferPositionsStart = (  ) => {
    return {
        type: actionTypes.UPDATE_PROJECTOFFERPOSITIONS_START
    };
};

const updateProjectOfferPositionsSuccess = ( projectOfferPositions ) => {
    return {
        type: actionTypes.UPDATE_PROJECTOFFERPOSITIONS_SUCCESS,
        values: projectOfferPositions
    };
};

const updateProjectOfferPositionsFailed = () => {
    return {
        type: actionTypes.UPDATE_PROJECTOFFERPOSITIONS_FAILED
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/projectOfferPositions.js